import React, { useState } from 'react'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Box from '@material-ui/core/Box'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import { LinearProgress } from '@material-ui/core'

import Footer from '../../components/Common/Footer'
import { auth } from '../../config/rebase'
import Back from '../../components/Common/Back'
import CustomAlert from '../../components/CustomAlert'
import { ERROR_MESSAGES } from '../../utils'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}))

export default function Login() {
    const classes = useStyles()

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const [error, setError] = useState(false)
    const [loaded, setLoaded] = useState(true)
    const [, setIsAuthenticated] = useState(false)

    const handleForm = async (e) => {
        e.preventDefault()

        setError(false)
        setLoaded(false)
        try {
            await auth.signInWithEmailAndPassword(email, password)
            return setIsAuthenticated(true)

        } catch (error) {
            const knownError = ERROR_MESSAGES.find(e => e.code === error.code)
            if (knownError) {
                return setError(knownError.translate)
            }
            setError('Ocorreu um erro... Verifique suas credenciais')
        } finally {
            setLoaded(true)
        }

    }

    if (!loaded) {
        return <LinearProgress />
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Back />
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">Login</Typography>
                <CustomAlert message={error} />
                <form className={classes.form} onSubmit={handleForm}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        onChange={e => setEmail(e.target.value)}
                        value={email}
                        fullWidth
                        id="email"
                        label="Endereço de E-mail"
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        onChange={e => setPassword(e.target.value)}
                        value={password}
                        fullWidth
                        name="password"
                        label="Senha"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Logar
          </Button>
                </form>
            </div>
            <Box mt={8}>
                <Footer />
            </Box>
        </Container>
    )
}
